import React, { FC, useState } from 'react'

import { EditUserAssignProjectsContent } from 'src/components/organisms/users/EditUserAssignProjectsContent'
import { UserAssignProjectsContent } from 'src/components/organisms/users/UserAssignProjectsContent'

import { AssignedProjectEntity, AssignedProjectSearchContentEntity, UserEntity } from 'src/types'
import { CompassRoleEntity } from 'src/types/entities/CompassRole'

type Props = {
  user: UserEntity
  projects: AssignedProjectEntity[]
  compassRoles: CompassRoleEntity[]
  onClickRow: (project: AssignedProjectEntity) => void
  className?: string
}

/**
 * ユーザー詳細のアサインプロジェクトを表示するメイン部分。
 * 詳細を表示するモーダルまで含めるとコンポーネントが大きくなってしまうため分離させたコンポーネント
 */
export const UserAssignProjectsMain: FC<Props> = ({
  user,
  projects,
  compassRoles,
  onClickRow,
  className,
}) => {
  const [isEditMode, setIsEditMode] = useState(false)
  const [searchContent, setSearchContent] = useState<AssignedProjectSearchContentEntity | null>(
    null
  )

  const editButtonId = 'ignore-click-away-edit-button'
  const cancelButtonId = 'ignore-click-away-cancel-button'

  return (
    <div className={className}>
      {isEditMode ? (
        <EditUserAssignProjectsContent
          user={user}
          projects={projects}
          compassRoles={compassRoles}
          searchContent={searchContent}
          editButtonId={editButtonId}
          cancelButtonId={cancelButtonId}
          onUpdateSearchContent={setSearchContent}
          onToNormalMode={() => setIsEditMode(false)}
        />
      ) : (
        <UserAssignProjectsContent
          projects={projects}
          onClickRow={onClickRow}
          searchContent={searchContent}
          editButtonId={editButtonId}
          cancelButtonId={cancelButtonId}
          onUpdateSearchContent={setSearchContent}
          onToEditMode={() => setIsEditMode(true)}
        />
      )}
    </div>
  )
}
